import { useMemo } from 'react';

interface BubbleProps {
  id: number;
  size: number;
  left: number;
  delay: number;
  duration: number;
}

const Bubble = ({ size, left, delay, duration }: Omit<BubbleProps, 'id'>) => {
  return (
    <div 
      className="bubble"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        left: `${left}%`,
        animationDelay: `${delay}s`,
        animationDuration: `${duration}s`,
      }}
    />
  );
};

const Bubbles = ({ count = 20 }) => {
  const bubbles = useMemo(() => {
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      size: 4 + Math.random() * 8,
      left: 10 + Math.random() * 80,
      delay: Math.random() * 3,
      duration: 2 + Math.random() * 2,
    }));
  }, [count]);

  return (
    <div className="bubbles-container">
      {bubbles.map((bubble) => (
        <Bubble key={bubble.id} {...bubble} />
      ))}
    </div>
  );
};

export default Bubbles;
